import { render, staticRenderFns } from "./bannerAbout.vue?vue&type=template&id=f29990a2&"
import script from "./bannerAbout.vue?vue&type=script&lang=js&"
export * from "./bannerAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports